import React, { Component } from 'react'
import ListLists from '../../Services/Queries/ListLists'
import AddPageToPeopleService from '../../Services/Mutations/AddPageToPeopleService'
import { Auth } from 'aws-amplify'
import { Button, Modal } from 'react-bootstrap'
import ListPages from '../../Services/Queries/ListPages'
class AddPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: '',
      pagesList: [],
      limit: 10,
      nextToken: null,
      endReached: false,
      spinner: true,
      selectedPages: [],
      modalVisible: false,
      sectionLabel_Te: '',
      sectionLabel_Hi: '',
      sectionLabel_En: '',
      isMainList: false,
      sortType: 'date',
      selectedSectionColumns: '1',
      selectedSectionScroll: 'horizontal',
      addingNewItemsTo: 0,
      showAsSubPage: false,
      showAfter: '',
    }
    this.sectionColumns = [1, 2]
    this.sectionScroll = ['horizontal', 'vertical']
    this.sectionLabelLanguages = ['Te', 'Hi', 'En']
  }
  getPageLists = async (searchQuery) => {
    const input = {
      limit: this.state.limit,
    }
    if (searchQuery) {
      input.search = searchQuery
    }
    console.log(input, 'input in page==============')
    const data = await ListPages(input)
    console.log(data, 'dataaaa')
    this.setState({
      spinner: false,
      pagesList: data.items,
      nextToken: data.nextToken,
      endReached: data.nextToken != null ? false : true,
    })
  }
  getNextPagesLists = async () => {
    if (!this.state.endReached) {
      const input = {
        limit: this.state.limit,
        nextToken: this.state.nextToken,
      }
      const data = await ListPages(input)
      this.setState({
        spinner: false,
        pagesList: [...this.state.pagesList, ...data.items],
        nextToken: data.nextToken,
        endReached: data.nextToken != null ? false : true,
      })
    }
  }
  onChangeSearch = (searchQuery) => {
    this.setState({ searchQuery: searchQuery })
    this.getPageLists(searchQuery)
  }
  async componentDidMount() {
    if (this.props.selectedTab == 'Page') {
      this.getPageLists()
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTab != this.props.selectedTab && this.props.selectedTab == 'Page') {
      this.setState({ searchQuery: '' })
      this.getPageLists()
    }
  }
  buttonVisibilityFunc = () => {
    return this.state.selectedPages.length
  }
  selectPage = (selectedPage) => {
    const index = this.state.selectedPages.findIndex((item) => item.SK == selectedPage.SK)
    const selectedPages = this.state.selectedPages
    if (index == -1) {
      selectedPages.push(selectedPage)
    } else {
      selectedPages.splice(index, 1)
    }
    this.setState({ selectedPages: selectedPages })
  }
  buttonVisibilityFunc2 = () => {
    return this.hasSectionlabelError()
  }
  addPage = async () => {
    const input = {
      sectionPosition: this.props.sectionPosition,
      sectionLabel_Te: this.state.sectionLabel_Te,
      sectionLabel_En: this.state.sectionLabel_En,
      sectionLabel_Hi: this.state.sectionLabel_Hi,
    }
    let data
    if (this.props.type == 'people') {
      input.sectionType = 'page'
      input.peopleValue = this.props.peopleValue
      input.sectionDetails = this.state.selectedPages
      input.sortBy = this.state.sortType
      input.sectionColumns = this.state.selectedSectionColumns
      input.sectionScroll = this.state.selectedSectionScroll
      input.displayAfter = parseInt(this.state.showAfter)
      input.showAsSubPage = this.state.showAsSubPage
      input.sectionConfigType = this.state.isMainList ? 'mainList' : 'NO'
      // data = await AddPageToPeopleService(input)
    }
    // console.log(data, 'datatttttt')
    this.setState({ modalVisible: false })
    this.props.addPeopleSections(input)

    this.props.closeListCollectionModal()
    // else if (this.props.params.type == 'page') {
    //   input.addedPages = this.state.selectedPages
    //   input.pageValue = this.props.params.pageValue
    //   data = await AddPageToPageService(input)
    // }
    // if (data && (data.statusCode == 'A288' || data.statusCode == 'A291')) {
    //   this.setState({ modalVisible: false, spinner: false }, () => {
    //     this.props.navigation.goBack()
    //   })
    // } else {
    //   this.setState({ modalVisible: false, spinner: false })
    // }
  }
  _rowRenderer(item) {
    const index = this.state.selectedPages.findIndex((page) => page.pageValue == item.pageValue)
    const backgroundColor = index != -1 ? '#999999' : null
    return (
      <div>
        <div
          style={{ marginBottom: '5px', backgroundColor: backgroundColor }}
          onClick={() => {
            this.selectPage(item)
          }}
        >
          <img
            style={{ width: '30px', height: '30px', borderRadius: '20px', marginRight: '5px' }}
            src={item.pageThumbnail}
          />
          <text>{item.pageTitle}</text>
        </div>
      </div>
    )
  }
  loadMore = async () => {
    await this.getNextPagesLists()
  }
  closeModal = () => {
    this.setState({ modalVisible: false })
  }
  handleHiSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Hi: sectionLabel })
  }
  handleEnSectionLabel = (e) => {
    const sectionLabel = e.target.value
    this.setState({ sectionLabel_En: sectionLabel })
  }
  handleTeSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Te: sectionLabel })
  }
  hasSectionlabelError = () => {
    return this.state.sectionLabel_Te || this.state.sectionLabel_En || this.state.sectionLabel_Hi
  }
  handleSortOption = async (sortValue) => {
    const { sortType } = this.state
    if (sortValue != sortType) {
      this.setState({ sortType: sortValue })
    }
  }
  handleShowAfter = (e) => {
    const showAfter = e.target.value
    this.setState({ showAfter })
  }
  toggleMainList = () => {
    this.setState({ isMainList: !this.state.isMainList })
  }
  selectSectionColumn = (sectionColumn) => {
    this.setState({ selectedSectionColumns: sectionColumn })
  }
  selectSectionScroll = (sectionScroll) => {
    this.setState({ selectedSectionScroll: sectionScroll })
  }

  renderModal = () => {
    const { sectionLabel_En, sectionLabel_Hi, sectionLabel_Te, sortType, showAfter } = this.state
    return (
      <div>
        <Modal show={this.state.modalVisible} onHide={() => this.closeModal()}>
          <Modal.Body>
            <div>
              <label for='text'>sectionLabel_En</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleEnSectionLabel(e)
                  }}
                  value={sectionLabel_En}
                  placeholder='Please Enter sectionLabel_En'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Te</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleTeSectionLabel(e)
                  }}
                  value={sectionLabel_Te}
                  placeholder='Please Enter sectionLabel_Te'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Hi</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleHiSectionLabel(e)
                  }}
                  value={sectionLabel_Hi}
                  placeholder='Please Enter sectionLabel_Hi'
                ></input>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <div>
                    <text>Section Columns</text>
                    <div>
                      {this.sectionColumns.map((itemType) => {
                        return (
                          <div className='col-md-3'>
                            <input
                              value={itemType}
                              type='radio'
                              checked={this.state.selectedSectionColumns == itemType}
                              onChange={() => this.selectSectionColumn(itemType)}
                            ></input>
                            <text for={itemType}>{itemType}</text>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div>
                    <text>Section Scroll</text>
                    <div>
                      {this.sectionScroll.map((itemType) => {
                        return (
                          <div className='col-md-3'>
                            <input
                              value={itemType}
                              type='radio'
                              checked={this.state.selectedSectionScroll == itemType}
                              onChange={() => this.selectSectionScroll(itemType)}
                            ></input>
                            <text for={itemType}>{itemType}</text>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div>
                    <text>{'Show After Number Of Records'}</text>
                    <div>
                      <input
                        type='text'
                        value={showAfter}
                        onChange={(e) => {
                          this.handleShowAfter(e)
                        }}
                        placeholder='Enter Show After Number Of Records'
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          {!this.hasSectionlabelError() ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Enter Section Label
            </text>
          ) : null}

          <Modal.Footer>
            {this.buttonVisibilityFunc2() ? (
              <Button onClick={() => this.addPage()}>Submit</Button>
            ) : (
              <Button disabled>Submit</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  render() {
    const {
      spinner,
      pagesList,
      modalVisible,
      sectionLabel_Te,
      sectionLabel_Hi,
      sectionLabel_En,
    } = this.state
    return (
      <div>
        <label for='gsearch'>Search Page:</label>
        <input
          type='text'
          onChange={(e) => {
            this.onChangeSearch(e.target.value)
          }}
          value={this.state.searchQuery}
          placeholder='Enter Page Name'
        ></input>
        {pagesList.map((list, index) => {
          return <div>{this._rowRenderer(list)}</div>
        })}
        {this.state.modalVisible ? this.renderModal() : null}

        {this.state.nextToken != null ? (
          <button onClick={() => this.loadMore()}>Load More</button>
        ) : null}
        {this.buttonVisibilityFunc() ? (
          <Button onClick={() => this.setState({ modalVisible: true })}>Continue</Button>
        ) : (
          <Button disabled>Continue</Button>
        )}
      </div>
    )
  }
}
export default AddPage
